'use strict';
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

var path = require('path');
var urlConfig = require('./url.config');
var isPdtType = process.env.type === '"pdt"';
var targetDeploymentDirName = isPdtType ? 'dist-pdt' : 'dist-uat';
var baiduStatisticalKey = isPdtType
    ? 'bc3656cd4fbe401685f9b9bc4e47a4d8'
    : 'a912f22a812c5fc02a5d2cf8d61570b9';

module.exports = {
    dev: {
        // Paths
        assetsSubDirectory: 'static',
        assetsPublicPath: '/accountcenter',
        proxyTable: {},

        // Various Dev Server settings
        host: urlConfig.dev.host, // can be overwritten by process.env.HOST
        port: 8083, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
        autoOpenBrowser: false,
        errorOverlay: true,
        notifyOnErrors: true,
        poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-


        /**
         * Source Maps
         */

        // https://webpack.js.org/configuration/devtool/#development
        devtool: 'cheap-module-eval-source-map',

        // If you have problems debugging vue-files in devtools,
        // set this to false - it *may* help
        // https://vue-loader.vuejs.org/en/options.html#cachebusting
        cacheBusting: true,

        cssSourceMap: true,
        baiduStatisticalKey: baiduStatisticalKey,
        ajaxUrl: urlConfig.dev.ajaxUrl,
        platformUrl: urlConfig.dev.platformUrl,
        backIndexUrl: urlConfig.dev.backIndexUrl
    },
    build: {
        // Template for index.html
        index: path.resolve(__dirname, '../' + targetDeploymentDirName + '/accountcenter/index.html'),

        // Paths
        assetsRoot: path.resolve(__dirname, '../' + targetDeploymentDirName),
        assetsSubDirectory: 'static',
        assetsPublicPath: '/accountcenter',

        /**
         * Source Maps
         */

        productionSourceMap: true,
        // https://webpack.js.org/configuration/devtool/#production
        devtool: '#source-map',

        // Gzip off by default as many popular static hosts such as
        // Surge or Netlify already gzip all static assets for you.
        // Before setting to `true`, make sure to:
        // npm install --save-dev compression-webpack-plugin
        productionGzip: true,
        productionGzipExtensions: ['js', 'css'],

        // Run the build command with an extra argument to
        // View the bundle analyzer report after build finishes:
        // `npm run build --report`
        // Set to `true` or `false` to always turn it on or off
        bundleAnalyzerReport: process.env.npm_config_report,
        baiduStatisticalKey: baiduStatisticalKey,
        ajaxUrl: urlConfig.uat.ajaxUrl,
        platformUrl: urlConfig.uat.platformUrl,
        backIndexUrl: urlConfig.uat.backIndexUrl
    },
    pdt: {
        baiduStatisticalKey: baiduStatisticalKey,
        ajaxUrl: urlConfig.pdt.ajaxUrl,
        platformUrl: urlConfig.pdt.platformUrl,
        backIndexUrl: urlConfig.pdt.backIndexUrl
    }
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1 2 3 4 5 6 7 8